<template>
  <div class="content">
    <div class="banner">
      <div class="title">地区规模</div>
      <div class="sub-title">一键预估</div>
    </div>
    <div class="inpBox">
      <div class="inps">
        <div class="key"><span style="color: rgba(207, 57, 57, 1)">*</span>选择地区</div>
        <div class="value">
          <div></div>
          <div class="select" style="display: flex;align-items: center">
<!--            请选择区县-->
<!--            <img src="../../assets/image/jiantou.png" alt="" class="jt">-->
            <el-cascader
                v-model="value"
                :options="options"
                @change="handleChange"
                :props="{value:'label'}"
                class="selects"
            ></el-cascader>
          </div>
        </div>
      </div>
      <div class="inps">
        <div class="key"><span style="color: rgba(207, 57, 57, 1)">*</span>输入该地区人口维度</div>
        <div class="value">
          <input type="text" class="inpa" v-model="peopleNun">
          <div class="tet">万人</div>
        </div>
      </div>
      <div class="inps" v-if="dataInfo">
        <div class="key">预估收益结果</div>
        <div class="value">
<!--          <input type="text" class="inpa" v-model="peopleNun">-->
          <div class="tet" style="font-size: 45px;color: #D17C3E;text-align: right">{{ dataInfo.value }}万元</div>
        </div>
      </div>
      <div class="inps" v-if="!dataInfo">
        <div class="key"><span style="color: rgba(207, 57, 57, 1)">*</span>输入验证手机号</div>
        <div class="value">
          <input type="text" class="inp" v-model="phone">
          <div class="send" @click="sendBtn" v-if="time==0">发送验证码</div>
          <div class="send" v-if="time!=0">{{ time }}S后重试</div>
        </div>
      </div>
      <div class="inps" v-if="!dataInfo">
        <div class="key"><span style="color: rgba(207, 57, 57, 1)">*</span>输入验证码</div>
        <div class="value">
          <input type="text" class="inp" v-model="code">
        </div>
      </div>
      <div class="next" @click="enter" v-if="!dataInfo">一键预测</div>
      <div class="next" @click="dataInfo=null;reset()" v-if="dataInfo">重新预测</div>
    </div>
    <div class="banner2">
      <div class="title">一个公开、公平、公正的市场环境</div>
      <div class="btns">
        <div class="btn" @click="goLink">立即登录</div>
        <div class="btn-login" @click="goInfo('/scale')">预估规模</div>

      </div>
    </div>
  </div>
</template>

<script>
import {getAssessment,sendAliyun} from '@/api'
import city from '@/utils/city'
export default {
  data() {
    return {
      provinceName:'',
      cityName:'',
      districtName:'',
      deviceType:'pc',
      code:'',
      phone:'',
      peopleNun:'',


      value: [],
      options: [],

      time:0,
      dataInfo:null
    }
  },
  created() {
    console.log(city)
    this.options = city
  },
  methods:{
    enter(){
      getAssessment({
        provinceName:this.provinceName,
        cityName:this.cityName,
        districtName:this.districtName,
        deviceType:'pc',
        code:this.code,
        phone:this.phone,
        peopleNun:this.peopleNun,
      }).then(res=>{
        console.log(res)
        if(res.code==200){
          this.dataInfo = res.data
        }
      })
    },
    reset(){
      this.provinceName=''
      this.cityName=''
      this.districtName=''
      this.deviceType='pc'
      this.code=''
      this.phone=''
      this.peopleNun=''
    },
    sendBtn(){
      if(!this.phone){
        this.$message({
          message: '请输入手机号',
          type: 'warning'
        });
        return
      }
      sendAliyun({
        phones:this.phone
      }).then(res=>{
        console.log(res)
        if(res.code==200){
          this.$message({
            message: '发送成功',
            type: 'success'
          });
          this.time = 60
          let djs = setInterval(()=>{
            this.time--
            if(this.time<=0){
              this.time=0
              clearInterval(djs)
            }
          },1000)

        }
      })
    },
    handleChange(e){
      console.log(e)
      this.provinceName=e[0]
      this.cityName=e[1]
      this.districtName=e[2]
    },
    goInfo(i){
      this.$router.push(i)

    },
    goLink(){
      window.location.href = 'http://admin.llbx.com.cn/'
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-input__inner{
  background: rgba(0,0,0,0);
  border:none;
  height: 56px;
}
</style>
<style lang="scss" scoped>
.content{
  width: 100%;
  //padding-bottom: 300px;
  .banner2{
    width: 100%;
    height: 372px;
    background-image: url("../../assets/image/gp.png");
    background-size: 100% 100%;
    padding: 1px;
    box-sizing: border-box;
    .title{
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 48px;
      color: #B58D4F;
      line-height: 67px;
      text-align: left;
      font-style: normal;
      margin-top: 79px;
      margin-left: 261px;
    }
    .btns{
      margin-top: 71px;
      margin-left: 261px;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      .btn-login{
        width: 157px;
        height: 60px;
        border-radius: 30px;
        border: 1px solid #B58D4F;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 25px;
        color: #DD9C38;
        line-height: 60px;
        text-align: center;
        font-style: normal;
        margin-left: 39px;
      }
      .btn{
        width: 157px;
        height: 60px;
        background: #B58D4F;
        border-radius: 30px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 25px;
        color: #FFFFFF;
        line-height: 60px;
        text-align: center;
        font-style: normal;
      }
    }
  }
  .banner{
    width: 100%;
    height: 819px;
    background-image: url("../../assets/image/scaleBg.png");
    background-size: 100% 100%;
    padding: 1px;
    box-sizing: border-box;
    .title{
      font-family: HYCuYuan, HYCuYuan;
      font-weight: normal;
      font-size: 86px;
      color: #B58D4F;
      line-height: 126px;
      text-align: left;
      font-style: normal;
      margin-top: 283px;
      margin-left: 272px;
    }
    .sub-title{
      font-family: HYCuYuan, HYCuYuan;
      font-weight: normal;
      font-size: 86px;
      color: #CCCCCC;
      line-height: 126px;
      text-align: left;
      font-style: normal;
      //margin-top: 55px;
      margin-left: 272px;
    }
    .btns{
      margin-top: 71px;
      margin-left: 272px;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      .btn-login{
        width: 157px;
        height: 60px;
        border-radius: 30px;
        border: 1px solid #B58D4F;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 25px;
        color: #DD9C38;
        line-height: 60px;
        text-align: center;
        font-style: normal;
        margin-left: 39px;
      }
      .btn{
        width: 157px;
        height: 60px;
        background: #B58D4F;
        border-radius: 30px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 25px;
        color: #FFFFFF;
        line-height: 60px;
        text-align: center;
        font-style: normal;
      }
    }
  }
  .inpBox{
    width: 1400px;
    height: 734px;
    background: #FFFFFF;
    margin: 30px auto;
    padding: 66px 66px 100px 122px;
    box-sizing: border-box;
    .next{
      width: 431px;
      height: 108px;
      background: #B58D4F;
      border-radius: 54px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 36px;
      color: #FFFFFF;
      line-height: 108px;
      text-align: center;
      font-style: normal;
      margin: 101px auto 0 auto;
    }
    .inps{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 39px;
      .key{
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: rgba(123, 123, 123, 1);
        line-height: 30px;
        font-style: normal;
      }
      .value{
        width: 309px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #272727;
        line-height: 30px;
        font-style: normal;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        position: relative;
        .send{
          font-size: 18px;
          color: #272727;
          position: absolute;
          right: 5px;
        }
        .select{
          width: 100%;

          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 22px;
          color: #272727;
          line-height: 30px;
          font-style: normal;
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          .selects{
            width: 100%;
            height: 56px;
            background: rgba(216, 216, 216, .2);
            border-radius: 8px;
            border: none;
            outline: none;  /* 可选，移除焦点时的轮廓 */

          }
          .jt{
            width: 14px;
            height: 26px;
            margin-left: 40px;
          }
        }
        .inpa{
          width: 233px;
          height: 56px;
          background: rgba(216, 216, 216, .2);
          border-radius: 8px;
          border: none;
          outline: none;  /* 可选，移除焦点时的轮廓 */
        }
        .txt{
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #272727;
          line-height: 25px;
          //text-align: center;
          font-style: normal;

        }
        .inp{
          width: 100%;
          height: 56px;
          background: rgba(216, 216, 216, .2);
          border-radius: 8px;
          border: none;
          outline: none;  /* 可选，移除焦点时的轮廓 */
        }
      }
    }
  }



}
</style>
